// Rules for the photo staff upload for a venue, shared so the upload screen and the API agree.
// 640 × 360 is sharp on the booking site's photo banner on high-res screens and above the link
// preview minimum, while still accepting the 750–1000 px photos venues usually have to hand.
export const VENUE_PHOTO_MIN_WIDTH_PX = 640;
export const VENUE_PHOTO_MIN_HEIGHT_PX = 360;
export const VENUE_PHOTO_ASPECT = 16 / 9;
export const VENUE_PHOTO_MAX_BYTES = 10 * 1024 * 1024;
// A small file can unpack to a huge image, so photos over this many pixels are refused.
export const VENUE_PHOTO_MAX_PIXELS = 25_000_000;
export const VENUE_PHOTO_MIN_SIZE_MESSAGE = `That photo is too small. It needs at least ${VENUE_PHOTO_MIN_WIDTH_PX} by ${VENUE_PHOTO_MIN_HEIGHT_PX} pixels after cropping. Ask the venue for the original, or open the photo full-size before saving it.`;
